import PHASE from 'utils/constants/phases'
import roundCredits from 'utils/roundCredits'
import preSeasonDataEnhancer from './phases/preSeason'
import preRaceDataEnhancer from './phases/preRace'
import raceDataEnhancer from './phases/race'
import postRaceDataEnhancer from './phases/postRace'

export default function enhancer(input = {}, myUuid) {
    if (input.phase === PHASE.PRE_SEASON) return enhancerForAllPhases(preSeasonDataEnhancer(input))
    if (input.phase === PHASE.PRE_RACE) return enhancerForAllPhases(preRaceDataEnhancer(input))
    if (input.phase === PHASE.RACE) return enhancerForAllPhases(raceDataEnhancer(input, myUuid))
    if (input.phase === PHASE.POST_RACE) return enhancerForAllPhases(postRaceDataEnhancer(input))
    return enhancerForAllPhases(input)
}

function enhancerForAllPhases(input = {}) {
    if (input.credits) {
        return { ...input, credits: roundCredits(input.credits) }
    }
    return input
}



// WEBPACK FOOTER //
// src/utils/dataEnhancer/index.js